import clsx from "clsx";
import { useAtom, useSetAtom } from "jotai";
import { showDataSourcesAtom } from "../state";
import { Toggle } from "@/ui/atoms/Toggle/Toggle";
import { DataSource } from "../hooks/useColorizedValue";
import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import { AIMContextViewAtom } from "../state/context.state";

const DATA_SOURCES = [
    {
        key: DataSource.FINANCE_API,
        label: "Finance API",
        color: "bg-blue-500",
        textColor: "text-blue-500",
    },
    {
        key: DataSource.LEGACY_BACKEND,
        label: "Legacy Backend",
        color: "bg-cyan-500",
        textColor: "text-cyan-500",
    },
    {
        key: DataSource.SFDC,
        label: "SFDC",
        color: "bg-green-500",
        textColor: "text-green-500",
    },
    {
        key: DataSource.FINANCE_LAB,
        label: "Finance Lab",
        color: "bg-purple-500",
        textColor: "text-purple-500",
    },
    {
        key: DataSource.MEMO_TEXT,
        label: "LLM Web API",
        color: "bg-orange-500",
        textColor: "text-orange-500",
    },
] as const;

export function DataSourcesPanel() {
    const [showDataSources, setShowDataSources] = useAtom(showDataSourcesAtom);
    const setAIMContextView = useSetAtom(AIMContextViewAtom);

    return (
        <div
            className={clsx(
                "bg-default",
                "flex size-full flex-col gap-6 overflow-auto p-4",
            )}
        >
            <div className="pt-4">
                <RightSidebarButton
                    label="Close"
                    iconDirection="right"
                    onClick={() => {
                        setAIMContextView(null);
                    }}
                />
            </div>

            <div className="size-full">
                <h1 className={clsx("pageheading mb-4")}>Data Sources</h1>

                <div className={clsx("mb-6 flex items-center justify-between")}>
                    <div className={clsx("flex flex-col gap-1")}>
                        <span
                            className={clsx(
                                "text-sm font-semibold tracking-wide",
                            )}
                        >
                            Show Data Sources
                        </span>
                        <span className={clsx("subdued text-xs")}>
                            Display colored indicators on metrics
                        </span>
                    </div>
                    <Toggle
                        checked={showDataSources}
                        onChange={setShowDataSources}
                    />
                </div>

                <div className={clsx("flex flex-col gap-3")}>
                    <h2 className={clsx("text-sm font-semibold")}>
                        Available Sources
                    </h2>
                    {DATA_SOURCES.map((source) => (
                        <div
                            key={source.key}
                            className={clsx(
                                "flex items-center gap-3 rounded-lg p-3",
                                "bg-slate-800",
                            )}
                        >
                            <div
                                className={clsx(
                                    "size-4 rounded-full",
                                    source.color,
                                )}
                            />
                            <span className={clsx("body-s font-medium")}>
                                {source.label}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
